import useFlag from 'lane-shared/hooks/useFlag';
import { FeatureFlag } from 'constants-flags';

/**
 * Generated with generate-feature-flag-custom-hook.sh script
 * on 2025-02-07T14:25:59-0500.
 */
export function useVisitorValidationEnabled() {
  const isEnabled = useFlag<boolean>(
    FeatureFlag.VisitorManagementValidation,
    false
  );

  return Boolean(isEnabled);
}
